import React from 'react';
import { HelpCircleIcon } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Tengo que comprar equipo especial?',
    a: 'No, solo necesitas agua fría y tu propio cuerpo.'
  }, {
    q: '¿Funciona si tengo mucha ansiedad?',
    a: 'Sí, está diseñado específicamente para sistemas nerviosos en estado de alerta máxima.'
  }, {
    q: '¿Es un libro largo?',
    a: 'No, es un protocolo directo al grano para que puedas aplicarlo esta misma noche.'
  }];
  return <section className="py-16 md:py-24 bg-slate-800" data-id="element-5">
      <div className="max-w-3xl mx-auto px-4" data-id="element-6">
        <div className="text-center mb-12" data-id="element-7">
          <HelpCircleIcon className="w-12 h-12 text-blue-400 mx-auto mb-4" data-id="element-8" />
          <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-9">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-6" data-id="element-10">
          {faqs.map((faq, index) => <div key={index} className="bg-slate-900 rounded-xl p-6 md:p-8 border border-slate-700" data-id="element-11">
              <h3 className="text-xl font-bold text-white mb-3 flex items-start gap-3" data-id="element-12">
                <span className="text-blue-400 font-black" data-id="element-13">P:</span>
                {faq.q}
              </h3>
              <p className="text-slate-300 text-lg flex items-start gap-3" data-id="element-14">
                <span className="text-slate-500 font-black" data-id="element-15">R:</span>
                {faq.a}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}